module.exports = __webpack_public_path__ + "components/roadsurfer/static/roadsurfer-1600-e22fdd719f22d86b30590e9acc860463.jpg";